module.exports = __webpack_public_path__ + "static/img/logo_icon.ae43971b.svg";